import { CookieBanner as SharedCookieBanner } from "@regexsolver/web-shared/components/CookieBanner";

/**
 * Self-mounted into document.body by src/lib/mount-cookie-banner.ts so it
 * renders on every page at every viewport. The privacy policy lives on THIS
 * site, hence the relative link.
 */
const CookieBanner = () => (
  <SharedCookieBanner
    cookieDomain={process.env.ZUDOKU_PUBLIC_COOKIE_DOMAIN}
    privacyLink={
      <a
        href="/privacy"
        className="text-foreground font-medium underline underline-offset-4"
      >
        Privacy Policy
      </a>
    }
  />
);

export default CookieBanner;
